import * as React from "react";

export const DragIcon: React.FC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <path
        d="M7.75 10a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5h-16ZM7 15.75a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5h-16a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5h-16a.75.75 0 0 1-.75-.75Z"
        fill="#60264e"
      />
    </g>
  </svg>
);
